<template>
  <div id="app">
    <div class="header-and-content">
      <Header />
      <main role="main">
        <div class="container">
          <div class="row mt-5 mb-6">
            <div class="col-md-12" v-if="mainFault">
              <Offline />
            </div>
            <div class="col-md-12"  v-else>
              <router-view></router-view>
            </div>
          </div>
        </div>
      </main>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from './shared/Header.vue';
import Footer from './shared/Footer.vue';
import Offline from './shared/Offline.vue';

export default {
  name: 'app',
  components: {
    Header,
    Footer,
    Offline
  },
  computed: {    
    mainFault() {
      return window.grandFail == true;
    }
  }
};

</script>

<style lang="scss">
@import './assets/styles/common.scss';
@import '../node_modules/bootstrap/dist/css/bootstrap.css';
@import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
@import './assets/styles/cards.scss';
@import './assets/styles/transitions.scss';
@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro');
</style>



